module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mhip2-66290f3d8a44ad01bea2ac8a6698d07d.jpg";